/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const postSummary = () => {
  // const btns = document.querySelectorAll('.js-summary-expand');
  document.addEventListener('click', event => {
    const element = event.target;
    if (element.classList.contains('js-summary-expand')) {
      // btns.forEach(btn => {
      // btn.addEventListener('click', e => {
      const parent = element.parentNode.parentNode;
      parent.querySelectorAll('.js-summary-answer').forEach(text => {
        text.classList.toggle('u-hidden');
      });
    }
  });
  // });
};

export default postSummary;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/postSummary.js